<template>
  <default-layout>
    <event-navbar title="Sessions" />
    <v-runtime-template :template="header_content"></v-runtime-template>
    <div class="container-fluid">
      <talk-list :event-short-name="$route.params.shortName"></talk-list>
    </div>
    <v-runtime-template :template="footer_content"></v-runtime-template>
  </default-layout>
</template>

<script>

// @ is an alias to /src
import ListViewStorageMixin from './ListViewStorageMixin.js'
import VRuntimeTemplate from "v-runtime-template";
import TalkList from '@/components/speaker/talk-list.vue'
import EventNavbar from '@/components/EventNavbar.vue'
import DefaultLayout from '@/components/DefaultLayout.vue'

export default {
  name: 'HomeView',
  mixins: [ListViewStorageMixin],
  components: {
    TalkList, EventNavbar, VRuntimeTemplate, DefaultLayout
  },
  created() {
    this.fetchBannerContent('talks')
  },
}
</script>
